<template>
  <nuttrema-layout-schedules
     class="is-no-middle-margin-top"
     widthEast="20em"
    :showEast="true"
    :toggleShowEast="false">

    <template slot="central">

      <div class="choose-subscription-plan" :class="[`theme-${theme}`, { 'is-disabled': disabled }]">

        <div v-if="_get(InstanceSubscriptionOptions, 'error')" class="choose-subscription-plan__col">
          <nuttrema-form-alert :error="_get(InstanceSubscriptionOptions, 'error')"></nuttrema-form-alert>
        </div>

        <div class="choose-subscription-plan__col">

          <nuttrema-option-slider-group
             v-model="selected.plan.id"
            :title="$t('label.subscription_plan_top_level_title')"
            :disclaimer="$t('label.subscription_plan_top_level_disclaimer')"
            :theme="theme"
            :disabled="disabled"
            @input="handlePlanChanged">
            <nuttrema-option-slider-item
               v-for="plan in _get(InstanceSubscriptionOptions, 'data.SubscriptionPlans', [])"
              :key="plan.id"
              :value="plan.id"
              :option="plan"
              :selectedCurrencyID="selected.currency_id"
              :selectedCurrencyCode="selectedCurrencyCode"
              :disabled="disabled"
              :theme="theme">
            </nuttrema-option-slider-item>
          </nuttrema-option-slider-group>
        </div>

        <div class="choose-subscription-plan__col">
          <nuttrema-option-slider-group
             v-model="selected.plan.group.id"
            :theme="theme"
            :title="$t('label.select_your_main_activity')"
            @input="handlePlanGroupChanged">
            <nuttrema-option-slider-item
               v-for="group in _get(selected, 'plan.Children', [])"
              :theme="theme"
              :key="group.id"
              :value="group.id"
              :option="group">
              <p>{{ _get(group, 'name') }}</p>
            </nuttrema-option-slider-item>
          </nuttrema-option-slider-group>
        </div>

        <div class="choose-subscription-plan__col">
          <div class="choose-subscription-plan__features">
            <div class="features__title">
              <div class="features__title--text">{{ $t('label.payment_option') }}</div>
            </div>
            <div class="features__wrap">
              <subscription-option :theme="theme">
                <span slot="title">{{ $t('label.currency') }}</span>
                <nuttrema-radiocheck-group
                   v-model="selected.currency_id"
                   mode="radio"
                  :theme="theme"
                  :required="true">
                  <nuttrema-radiocheck-button
                     v-for="currency in _get(InstanceSubscriptionOptions, 'data.Currencies', [])"
                    :label="currency.id"
                    :key="currency.id">
                  {{ currency.symbol }} ({{ currency.name }})
                  </nuttrema-radiocheck-button>
                </nuttrema-radiocheck-group>
              </subscription-option>

              <subscription-option :theme="theme">
                <span slot="title">{{ $t('label.payment_plan') }}</span>
                <nuttrema-radiocheck-group
                   v-model="selected.payment_plan_id"
                   mode="radio"
                  :theme="theme"
                  :required="true">
                  <nuttrema-radiocheck-button
                     v-for="paymentPlan in _get(InstanceSubscriptionOptions, 'data.PaymentPlans', [])"
                    :label="paymentPlan.id"
                    :key="paymentPlan.id">
                  {{ paymentPlan.name }}
                  </nuttrema-radiocheck-button>
                </nuttrema-radiocheck-group>
              </subscription-option>
            </div>
          </div>
        </div>

        <div class="choose-subscription-plan__col">
          <div class="choose-subscription-plan__features"
            :class="{ 'is-show-less': !showAllFeatures && !customize }">
            <div class="features__title is-without-bottom-margin">
              <div class="features__title--text">{{ $t('label.features') }}</div>
              <div class="features__title--customize">
                <switch-small
                   class="switch-small"
                   v-model="customize"
                   active-color="#ffc107"
                   inactive-color="#dbe2f0"
                  :active-text="$t('label.customize_plan')">
                </switch-small>
              </div>
            </div>
            <div class="features__wrap">
              <p class="features__wrap__extend-plan is-first">{{ $t('label.included_in_plan') }}</p>
              <subscription-feature
                 v-for="feature in _get(selected, 'plan.group.SubscriptionFeatures.StandardFeatures', [])"
                 type="standard"
                :theme="theme"
                :key="feature.id"
                :feature="feature"
                :customize="customize"
                :selectedCurrencyID="selected.currency_id"
                :selectedPaymentPlanID="selected.payment_plan_id"
                @input="setSubscriptionFeature">
              </subscription-feature>

              <template v-if="!_isEmpty(_get(selected, 'plan.group.SubscriptionFeatures.ExtendedFeatures', []))">
                <p class="features__wrap__extend-plan">{{ $t('label.extra_option') }}</p>
                <subscription-feature
                   v-for="feature in _get(selected, 'plan.group.SubscriptionFeatures.ExtendedFeatures', [])"
                   type="extended"
                  :theme="theme"
                  :key="feature.id"
                  :feature="feature"
                  :customize="customize"
                  :selectedCurrencyID="selected.currency_id"
                  @remove="removeSubscriptionFeature"
                  @input="setSubscriptionFeature">
                </subscription-feature>
              </template>
            </div>
            <div class="features__more_less" v-if="!customize && _get(selected, 'plan.group.SubscriptionFeatures.StandardFeatures', []).length > 5">
              <a @click="showAllFeatures = !showAllFeatures">
                <span v-if="showAllFeatures">{{ $t('label.less') }}</span>
                <span v-else>{{ $t('label.more') }}</span>
              </a>
            </div>
          </div>
        </div>

      </div>
    </template>
    <!-- end ~ central -->

    <template slot="east">
      <subscription-east-summary-select-plan
         class="is-in-new-purchase"
        :bottom-summary="false"
        :summary="_get(selected, 'plan')"
        :currencyID="_get(selected, 'currency_id')"
        :paymentPlanID="_get(selected, 'payment_plan_id')"
        :processing="_get(InstanceSubscriptionOptions, 'saving')"
        :preconditions="_get(InstanceSubscriptionOptions, 'meta.preconditions')"
        @cancel="cancel"
        @nextStep="nextStep">
      </subscription-east-summary-select-plan>
    </template>
    <!-- end ~ east -->

  </nuttrema-layout-schedules>
</template>

<script>
import NuttremaLayoutSchedules from 'components/ui/layout/nuttrema-layout-schedules';

import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';

import ChooseSubscriptionPlan from './cmpt-choose-subscription-plan';
import SubscriptionEastSummarySelectPlan from './cmpt-subscription-east-summary-select-plan';

export default {
  name: 'cmpt-instance-purchase-new-select-plan',
  mixins: [ChooseSubscriptionPlan],
  components: {
    NuttremaFormAlert,
    NuttremaLayoutSchedules,
    SubscriptionEastSummarySelectPlan,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-instance-purchase-new-select-plan.vue